module.exports = __webpack_public_path__ + "media/images/icons/outlined/right-square-dcdb4d2774968f920de2d2da30297516.svg";